export const generateDynamicColors = (
  data: Array<{ name: string; value: number }>
) => {
  if (!data || data.length === 0) return [];

  const baseColor = '#8B5CF6';

  const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  };

  const baseRgb = hexToRgb(baseColor);
  if (!baseRgb) return data.map(() => baseColor);

  const values = data.map(d => d.value);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  const range = maxValue - minValue;

  if (range === 0) {
    return data.map(() => baseColor);
  }

  return data.map(item => {
    const normalizedValue = (item.value - minValue) / range;

    const saturation = 0.4 + normalizedValue * 0.6;

    const lightenFactor = 1 - saturation;

    const targetRgb = {
      r: Math.round(baseRgb.r * saturation + 255 * lightenFactor),
      g: Math.round(baseRgb.g * saturation + 255 * lightenFactor),
      b: Math.round(baseRgb.b * saturation + 255 * lightenFactor),
    };

    return `rgb(${targetRgb.r}, ${targetRgb.g}, ${targetRgb.b})`;
  });
};
